module.exports = __webpack_public_path__ + "img/7-WhiteCarrot.de84f071.jpg";